import {assert} from 'Asserts';
import {TagSchemaSummary} from 'constants/RegistryConstants';
import {BatchSchema} from 'constants/SampleConstants';
import {DataTable} from 'notebook/data-tables/DataTableConstants';
import {getPrimaryLinkField} from 'results/PrimaryLinks';
import {
  getRequiredLinkBatchSchema,
  getRequiredLinkTagSchema,
  SchemaField,
} from 'schemas/fields/SchemaFieldConstants';

import {TagSchemaSummaryGraphQL} from '../../../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaSummaryGraphQL';

function _getTargetSchemaIdForLinkContext(
  dataTable: DataTable,
  getRequiredLinkSchema: (
    field: SchemaField
  ) => TagSchemaSummary | TagSchemaSummaryGraphQL | BatchSchema | null
): string | null {
  const primaryLinkField = getPrimaryLinkField(dataTable.config.assaySchema);
  assert(primaryLinkField != null, 'Expected non-null primary link field for data table with link context');
  const targetSchema = getRequiredLinkSchema(primaryLinkField);
  return targetSchema ? targetSchema.id : null;
}

export function getTargetSchemaIdForFileLinkContext(dataTable: DataTable): string | null {
  return _getTargetSchemaIdForLinkContext(dataTable, getRequiredLinkTagSchema);
}

export function getTargetSchemaIdForBatchLinkContext(dataTable: DataTable): string | null {
  return _getTargetSchemaIdForLinkContext(dataTable, getRequiredLinkBatchSchema);
}
